<template>
    <div class="Costs">
        <div class="InitialCosts">
            <h5>{{'Initial Costs' | language}}</h5>
            <table>
                <tbody>
                    <tr v-for="(cost,index) of property.init_costs" :key="index">
                        <td v-if="cost.pivot.flt_cost || cost.pivot.bit_inquiry || property.bit_inquiry_all">
                            <strong v-if="$store.state.general.language ==='english'">{{cost.str_initial_cost_name_en}}:</strong>
                            <strong v-else>{{cost.str_initial_cost_name_jp}}:</strong>
                        </td>
                        <td v-if="cost.pivot.flt_cost && !cost.pivot.bit_inquiry && !property.bit_inquiry_all">
                                {{cost.pivot.flt_cost | currency('¥',0)}}
                        </td>
                        <td v-if="cost.pivot.bit_inquiry || property.bit_inquiry_all">{{'Please Inquire' | language}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="MonthlyCosts">
            <h5>{{'Monthly Costs' | language}}</h5>
            <table>
                <tbody>
                    <tr  v-for="(cost,index) of property.monthly_costs" :key="index">
                    <td v-if="cost.pivot.flt_cost || cost.pivot.bit_inquiry || property.bit_inquiry_all">
                        <strong v-if="$store.state.general.language === 'english'">{{cost.str_monthly_cost_name_en}}:</strong>
                        <strong v-else>{{cost.str_monthly_cost_name_jp}}:</strong>
                    </td>
                    <td v-if="cost.pivot.flt_cost && !cost.pivot.bit_inquiry && !property.bit_inquiry_all">
                            {{cost.pivot.flt_cost | currency('¥',0)}}
                    </td>
                    <td v-if="cost.pivot.bit_inquiry || property.bit_inquiry_all">{{'Please Inquire' | language}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'listing-costs',
        props: {
            property: Object
        }
    }
</script>

<style lang="scss">
    .InitialCosts, .MonthlyCosts {
        display: inline-block;
        width: 100%;

        table {
            table-layout: fixed;

            tbody {
                padding: 0;
            }

            tr {
                td {
                    &:first-child {
                        padding-left: 0;
                    }
                }
            }
        }
    }
</style>




